export default __webpack_public_path__ + "static/media/classic2.9d6392dd.jpg";